import { render, staticRenderFns } from "./BadgeActionable.vue?vue&type=template&id=25f2198a"
import script from "./BadgeActionable.vue?vue&type=script&lang=js"
export * from "./BadgeActionable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports